import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose } from '@travel-frontend/icons';
import { noop } from 'lodash';
import { forwardRef } from 'react';
import { Body } from '../../../../components/SearchForm/components/WidgetChrome/components/Body.js';
import { Content } from '../../../../components/SearchForm/components/WidgetChrome/components/Content.js';
import { Controls } from '../../../../components/SearchForm/components/WidgetChrome/components/Controls.js';
import { DrawerContainer } from '../../../../components/SearchForm/components/WidgetChrome/components/DrawerContainer.js';
import { Header } from '../../../../components/SearchForm/components/WidgetChrome/components/Header.js';
import { PopoverContainer } from '../../../../components/SearchForm/components/WidgetChrome/components/PopoverContainer.js';
import { IconButton } from '../../../../primitives/index.js';
export const WidgetChrome = forwardRef(function WidgetChrome({
  type,
  title,
  head,
  controls,
  aside,
  asideRight,
  children,
  onClose = noop,
  allowOverflow = false,
  topControls,
  removePadding,
  reverse,
  ...restProps
}, ref) {
  if (type === 'drawer') {
    return _jsxs(DrawerContainer, {
      ...restProps,
      ref: ref,
      children: [(head || title) && _jsxs(Header, {
        center: !head,
        children: [_jsx("span", {
          children: head || title
        }), _jsx(IconButton, {
          round: true,
          variant: "info",
          category: "tertiary",
          onClick: onClose,
          children: _jsx(IconClose, {})
        })]
      }), topControls, _jsx(Content, {
        allowOverflow: allowOverflow,
        children: children
      }), controls && _jsx(Controls, {
        children: controls
      })]
    });
  }
  return _jsxs(PopoverContainer, {
    ...restProps,
    ref: ref,
    direction: "row",
    spacing: "none",
    reverse: reverse,
    children: [aside, _jsxs(Body, {
      removePadding: removePadding,
      spacing: "none",
      children: [head, topControls, _jsx(Content, {
        allowOverflow: allowOverflow,
        children: children
      }), controls && _jsx(Controls, {
        children: controls
      })]
    }), asideRight]
  });
});